// extracted by mini-css-extract-plugin
export default {"placeholder":"AdvancedReport_placeholder__fwp6Z","placeholderIcon":"AdvancedReport_placeholderIcon__vjjoo"};